import { ChangeDetectionStrategy, Component } from '@angular/core';
import { environment } from '../../../environments/environment';

@Component({
  selector: 'version-no',
  imports: [],
  templateUrl: './version-no.component.html',
  styleUrl: './version-no.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class VersionNoComponent {
  readonly versionNo = environment.versionNo;
}
